import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ScrEnvironment } from 'src/environments/environment';
import { WithCredNoCache, pdfDownload } from './authentication.service';
import { ScrServiceManager } from './servicemanager.service';
import { octetStreamDownload } from './authentication.service';
import { ScrBaseService } from './base.service';
import { GetRegistryReportResponse } from './carrier-report.service';


export type DocumentType = 'statement' | 'receipt' | 'invoice' | 'bulkreceipt';

@Injectable({
  providedIn: 'root'
})
export class SdDownloadsService extends ScrBaseService {

  constructor(
    serviceManager: ScrServiceManager,
    private environment: ScrEnvironment,
    private http: HttpClient) {
    super(serviceManager);
  }

  
  /**
   * This service desk version pulls ONLY the daily registry report S3 link.
   * @returns 
   */
  getRegistryReport(): Observable<GetRegistryReportResponse> {
    // shared functionality with carrier users.
    const url = `${this.environment.base}/sd/document/registryreportlink`;
    return this.http.get<GetRegistryReportResponse>(url, WithCredNoCache);
  }


  downloadShortCodeExpiration(accountId: string|number, dateRange: string): Observable<HttpResponse<Blob>> {
    const url = `${this.environment.base}/secure2/customerreports/shortcodeexpiration?type=${dateRange}&accountId=${accountId}`;
    // const url = `${this.environment.base}/sd/secure/accounts/${accountId}/customerreports/shortcodeexpirationn?type=${dateRange}`;
    return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
  }

  downloadShortCodeList(accountId: string|number) {
    const url = `${this.environment.base}/secure2/customerreports/shortcodelist?accountId=${accountId}`;
    return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
  }

  downloadBrandList(accountId: string|number) {
    const url = `${this.environment.base}/secure2/customerreports/brandlist?accountId=${accountId}`;
    return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
  }

  downloadContentProviderList(accountId: string|number) {
    const url = `${this.environment.base}/secure2/customerreports/contentProviderlist?accountId=${accountId}`;
    return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
  }


  downloadShortCodeBrand(accountId: string|number) {
    const url = `${this.environment.base}/secure2/customerreports/shortcodebrand?accountId=${accountId}`;
    return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
  }

  downloadPaymentSummary(accountId: string|number, type: string, retrieveBy: string, start?: string, end?: string, unpaidInvoices?: boolean) {
    let url;
    if (start && end)
      url = `${this.environment.base}/secure2/customerreports/paymentsummary?type=${type}&unpaidInvoices=${unpaidInvoices}&startDate=${start}&endDate=${end}&retrieveBy=${retrieveBy}&accountId=${accountId}`;
    else if (start)
      url = `${this.environment.base}/secure2/customerreports/paymentsummary?type=${type}&unpaidInvoices=${unpaidInvoices}&startDate=${start}&retrieveBy=${retrieveBy}&accountId=${accountId}`;
    else if (end)
      url = `${this.environment.base}/secure2/customerreports/paymentsummary?type=${type}&unpaidInvoices=${unpaidInvoices}&endDate=${end}&retrieveBy=${retrieveBy}&accountId=${accountId}`;
    else
      url = `${this.environment.base}/secure2/customerreports/paymentsummary?type=${type}&unpaidInvoices=${unpaidInvoices}&retrieveBy=${retrieveBy}&accountId=${accountId}`;


    return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
  }
  downloadShortCodeTransfer(accountId: string|number, type: string, start?: string, end?: string) {
    let url;
    if (start && end)
      url = `${this.environment.base}/secure2/customerreports/shortcodetransfers?type=${type}&startDate=${start}&endDate=${end}&accountId=${accountId}`;
    else
      url = `${this.environment.base}/secure2/customerreports/shortcodetransfers?type=${type}&accountId=${accountId}`;
    return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
  }


  sdShortCodeHistoryDownload(scId: string): Observable<HttpResponse<Blob>> {
    const url = `${this.environment.base}/sd/document/shortcodehistory/${scId}`;
    return this.http.get<HttpResponse<Blob>>(url, octetStreamDownload);
  }


  // use standard HTTP REST call for these.

  downloadDocument(id: number, type: DocumentType): Observable<HttpResponse<Blob>> {
    const url = `${this.environment.base}/sd/document/${type}/${id}`;
    return this.http.get<HttpResponse<Blob>>(url, pdfDownload);
  }

  /**
   * Have the back-end generate a PDF transfer statement on the fly.
   * @param scId - short code to generate the statement for.
   * @param orderId - associated order id.
   * @returns observable to watch for the http response.
   */
  getTransferDoc(scId: number, orderId: number): Observable<HttpResponse<Blob>> {
    const url = `${this.environment.base}/sd/document/transferstatement/${scId}/${orderId}`;
    return this.http.get<HttpResponse<Blob>>(url, pdfDownload);
  }


}
